import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _appEmbedData = { image: '_media' };
var _audioData = { audio: '_media', coverImage: '_media' };
var _background = { image: '_media' };
var _blogMedia = { wixMedia: '_wixMedia' };
var _bulkGetPostMetricsRequest = {};
var _bulkGetPostMetricsResponse = { metrics: 'Map#_metrics' };
var _bulkGetPostReactionsRequest = {};
var _bulkGetPostReactionsResponse = {};
var _category = { coverMedia: '_coverMedia', coverImage: '_image' };
var _coverMedia = { image: '_image', video: '_video' };
var _createDraftPostFromTemplateRequest = {};
var _createDraftPostFromTemplateResponse = { draftPost: '_draftPost' };
var _design = { poll: '_pollDesign' };
var _draftPost = {
    editedDate: 'google.protobuf.Timestamp',
    scheduledPublishDate: 'google.protobuf.Timestamp',
    firstPublishedDate: 'google.protobuf.Timestamp',
    createdDate: 'google.protobuf.Timestamp',
    coverMedia: '_coverMedia',
    heroImage: '_image',
    richContent: '_richContent',
    moderationDetails: '_moderationDetails',
    media: '_blogMedia',
};
var _galleryData = { items: '_item', options: '_galleryOptions' };
var _galleryOptions = { item: '_itemStyle' };
var _getPostBySlugRequest = {};
var _getPostBySlugResponse = { post: '_post' };
var _getPostMetricsRequest = {};
var _getPostMetricsResponse = { metrics: '_metrics' };
var _getPostRequest = {};
var _getPostResponse = { post: '_post' };
var _getTemplateRequest = {};
var _getTemplateResponse = { postTemplate: '_post' };
var _getTotalLikesPerMemberRequest = {};
var _getTotalLikesPerMemberResponse = {};
var _getTotalPostsRequest = {};
var _getTotalPostsResponse = {};
var _getTotalPublicationsRequest = {};
var _getTotalPublicationsResponse = {};
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _imageData = { image: '_media' };
var _item = { image: '_itemImage', video: '_itemVideo' };
var _itemImage = { media: '_media' };
var _itemStyle = { ratio: 'google.protobuf.DoubleValue' };
var _itemVideo = { media: '_media', thumbnail: '_media' };
var _likePostRequest = {};
var _likePostResponse = { post: '_post' };
var _listDemoPostsRequest = {};
var _listDemoPostsResponse = { posts: '_post' };
var _listPostsArchiveRequest = {};
var _listPostsArchiveResponse = { posts: '_post' };
var _listPostsRequest = {};
var _listPostsResponse = { posts: '_post' };
var _listTemplatesRequest = {};
var _listTemplatesResponse = {
    postTemplates: '_post',
    templateCategories: '_category',
};
var _mapData = { mapSettings: '_mapSettings' };
var _mapSettings = {
    lat: 'google.protobuf.DoubleValue',
    lng: 'google.protobuf.DoubleValue',
};
var _media = { duration: 'google.protobuf.DoubleValue' };
var _metadata = {
    createdTimestamp: 'google.protobuf.Timestamp',
    updatedTimestamp: 'google.protobuf.Timestamp',
};
var _metrics = { averageRating: 'FLOAT' };
var _moderationDetails = {
    submittedDate: 'google.protobuf.Timestamp',
    moderationDate: 'google.protobuf.Timestamp',
};
var _node = {
    galleryData: '_galleryData',
    imageData: '_imageData',
    mapData: '_mapData',
    pollData: '_pollData',
    appEmbedData: '_appEmbedData',
    videoData: '_videoData',
    audioData: '_audioData',
    nodes: '_node',
};
var _option = { image: '_media' };
var _periodPostCount = { periodStart: 'google.protobuf.Timestamp' };
var _periodPublicationsCount = { periodStart: 'google.protobuf.Timestamp' };
var _pinPostRequest = {};
var _pinPostResponse = { post: '_post' };
var _poll = { image: '_media', options: '_option' };
var _pollData = { poll: '_poll', design: '_design' };
var _pollDesign = { background: '_background' };
var _post = {
    firstPublishedDate: 'google.protobuf.Timestamp',
    lastPublishedDate: 'google.protobuf.Timestamp',
    richContentCompressed: 'google.protobuf.BytesValue',
    coverMedia: '_coverMedia',
    heroImage: '_image',
    metrics: '_metrics',
    richContent: '_richContent',
    moderationDetails: '_moderationDetails',
    media: '_blogMedia',
};
var _queryPostCountStatsRequest = {
    rangeStart: 'google.protobuf.Timestamp',
    rangeEnd: 'google.protobuf.Timestamp',
};
var _queryPostCountStatsResponse = { stats: '_periodPostCount' };
var _queryPostsRequest = {};
var _queryPostsResponse = { posts: '_post' };
var _queryPublicationsCountStatsRequest = {
    rangeStart: 'google.protobuf.Timestamp',
    rangeEnd: 'google.protobuf.Timestamp',
};
var _queryPublicationsCountStatsResponse = {
    stats: '_periodPublicationsCount',
};
var _richContent = { nodes: '_node', metadata: '_metadata' };
var _sendActionEventRequest = {};
var _sendActionEventResponse = {};
var _unlikePostRequest = {};
var _unlikePostResponse = { post: '_post' };
var _unpinPostRequest = {};
var _unpinPostResponse = { post: '_post' };
var _video = { thumbnail: '_image' };
var _videoData = { video: '_media', thumbnail: '_media' };
var _videoResolution = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    poster: '_image',
};
var _videoV2 = {
    urlExpirationDate: 'google.protobuf.Timestamp',
    resolutions: '_videoResolution',
    posters: '_image',
};
var _viewPostRequest = {};
var _viewPostResponse = {};
var _wixMedia = { image: '_image', videoV2: '_videoV2' };
function resolveWixBlogKafkaProducerV1PostKafkaProducerUrl(opts) {
    var domainToMappings = {};
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/blog/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/blog/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3MemberLikesServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/blog/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostTemplateServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'apps._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        _: [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/blogs/this',
                destPath: '/_api/blogs/this',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/categories',
                destPath: '/_api/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/site-properties',
                destPath: '/_api/site-properties',
            },
            {
                srcPath: '/_api/communities-blog-node-api/_api/posts/content',
                destPath: '/_api/posts/content',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/_api/communities-blog-node-api/v2/stats',
                destPath: '/v2/stats',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'social-blog._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/communities-blog-node-api',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/blog/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/blog/v3',
                destPath: '/v3',
            },
            {
                srcPath: '/v2/stats',
                destPath: '/v2/stats',
            },
            {
                srcPath: '/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/posts',
                destPath: '/v3/posts',
            },
            {
                srcPath: '/blog/v3/categories',
                destPath: '/v3/categories',
            },
            {
                srcPath: '/blog/v3/tags',
                destPath: '/v3/tags',
            },
            {
                srcPath: '/blog/v2/stats',
                destPath: '/v2/stats',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
function resolveComWixpressNpmCommunitiesPlatformizedBlogV3DemoPostServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/blog-demo-posts',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_serverless/blog-demo-posts',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieves a list of published demo posts. */
export function listDemoPosts(payload) {
    var _a = serializer(_listDemoPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDemoPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listDemoPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.DemoPostService.ListDemoPosts',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3DemoPostServiceUrl({ protoPath: '/v3/demo-posts', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDemoPosts.fromReq = fromReq;
    __listDemoPosts.__isAmbassador = true;
    return __listDemoPosts;
}
/** Retrieves available post templates and template categories if asked */
export function listTemplates(payload) {
    var _a = serializer(_listTemplatesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listTemplatesResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _category: _category,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listTemplates(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostTemplateService.ListTemplates',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostTemplateServiceUrl({ protoPath: '/v3/templates', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listTemplates.fromReq = fromReq;
    __listTemplates.__isAmbassador = true;
    return __listTemplates;
}
/** Gets post template by given id */
export function getTemplate(payload) {
    var _a = serializer(_getTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostTemplateService.GetTemplate',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostTemplateServiceUrl({
                protoPath: '/v3/templates/{postTemplateId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTemplate.fromReq = fromReq;
    __getTemplate.__isAmbassador = true;
    return __getTemplate;
}
/** Creates draft post from specified post template */
export function createDraftPostFromTemplate(payload) {
    var _a = serializer(_createDraftPostFromTemplateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createDraftPostFromTemplateResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _draftPost: _draftPost,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __createDraftPostFromTemplate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostTemplateService.CreateDraftPostFromTemplate',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostTemplateServiceUrl({ protoPath: '/v3/templates', data: serializedData, host: host }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createDraftPostFromTemplate.fromReq = fromReq;
    __createDraftPostFromTemplate.__isAmbassador = true;
    return __createDraftPostFromTemplate;
}
/** Retrieves total likes of a member. */
export function getTotalLikesPerMember(payload) {
    var _a = serializer(_getTotalLikesPerMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTotalLikesPerMemberResponse, {}).fromJSON;
    function __getTotalLikesPerMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.MemberLikesService.GetTotalLikesPerMember',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3MemberLikesServiceUrl({ protoPath: '/v3/member/{memberId}/likes', data: serializedData, host: host }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTotalLikesPerMember.fromReq = fromReq;
    __getTotalLikesPerMember.__isAmbassador = true;
    return __getTotalLikesPerMember;
}
/** Gets a post by the specified ID. */
export function getPost(payload) {
    var _a = serializer(_getPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPost.fromReq = fromReq;
    __getPost.__isAmbassador = true;
    return __getPost;
}
/** Gets a post with the provided slug. */
export function getPostBySlug(payload) {
    var _a = serializer(_getPostBySlugRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostBySlugResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __getPostBySlug(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPostBySlug',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/slugs/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostBySlug.fromReq = fromReq;
    __getPostBySlug.__isAmbassador = true;
    return __getPostBySlug;
}
/**
 * Retrieves a list of up to 100 published posts per request.
 *
 * List Posts runs with these defaults, which you can override:
 * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 */
export function listPosts(payload) {
    var _a = serializer(_listPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.ListPosts',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPosts.fromReq = fromReq;
    __listPosts.__isAmbassador = true;
    return __listPosts;
}
/**
 * Retrieves a list of up to 100 posts, given the provided paging, filtering, and sorting.
 *
 * Query Posts runs with these defaults, which you can override:
 * - `firstPublishedDate` is sorted in descending order, with pinned posts first.
 * - `paging.limit` is `50`.
 * - `paging.offset` is `0`.
 *
 * For field support for filters and sorting, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/api/rest/wix-blog/blog/posts/filter-and-sort).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/api/rest/getting-started/sorting-and-paging), and
 * [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 * For a detailed list of supported filters and sortable fields, see
 * [Field Support for Filtering and Sorting](https://dev.wix.com/api/rest/wix-blog/blog/filter-and-sort).
 */
export function queryPosts(payload) {
    var _a = serializer(_queryPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPostsResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __queryPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.QueryPosts',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPosts.fromReq = fromReq;
    __queryPosts.__isAmbassador = true;
    return __queryPosts;
}
/** Gets a specified post's metrics. */
export function getPostMetrics(payload) {
    var _a = serializer(_getPostMetricsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getPostMetricsResponse, {
        _metrics: _metrics,
    }).fromJSON;
    function __getPostMetrics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.GetPostMetrics',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/metrics',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getPostMetrics.fromReq = fromReq;
    __getPostMetrics.__isAmbassador = true;
    return __getPostMetrics;
}
/** Retrieves a specified posts metrics. */
export function bulkGetPostMetrics(payload) {
    var _a = serializer(_bulkGetPostMetricsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetPostMetricsResponse, {
        _metrics: _metrics,
    }).fromJSON;
    function __bulkGetPostMetrics(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.BulkGetPostMetrics',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/metrics',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetPostMetrics.fromReq = fromReq;
    __bulkGetPostMetrics.__isAmbassador = true;
    return __bulkGetPostMetrics;
}
/** Increment view counter of a post. */
export function viewPost(payload) {
    var _a = serializer(_viewPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_viewPostResponse, {}).fromJSON;
    function __viewPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.ViewPost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/view',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __viewPost.fromReq = fromReq;
    __viewPost.__isAmbassador = true;
    return __viewPost;
}
/** Like post */
export function likePost(payload) {
    var _a = serializer(_likePostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_likePostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __likePost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.LikePost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/like',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __likePost.fromReq = fromReq;
    __likePost.__isAmbassador = true;
    return __likePost;
}
/** Unlike post */
export function unlikePost(payload) {
    var _a = serializer(_unlikePostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unlikePostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __unlikePost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.UnlikePost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/unlike',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unlikePost.fromReq = fromReq;
    __unlikePost.__isAmbassador = true;
    return __unlikePost;
}
/** Pin post in the feed */
export function pinPost(payload) {
    var _a = serializer(_pinPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_pinPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __pinPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.PinPost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/pin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __pinPost.fromReq = fromReq;
    __pinPost.__isAmbassador = true;
    return __pinPost;
}
/** Unpin post in the feed */
export function unpinPost(payload) {
    var _a = serializer(_unpinPostRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_unpinPostResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __unpinPost(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.UnpinPost',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/{postId}/unpin',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __unpinPost.fromReq = fromReq;
    __unpinPost.__isAmbassador = true;
    return __unpinPost;
}
/** Retrieves a posts archive. */
export function listPostsArchive(payload) {
    var _a = serializer(_listPostsArchiveRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPostsArchiveResponse, {
        _appEmbedData: _appEmbedData,
        _audioData: _audioData,
        _background: _background,
        _blogMedia: _blogMedia,
        _coverMedia: _coverMedia,
        _design: _design,
        _galleryData: _galleryData,
        _galleryOptions: _galleryOptions,
        _image: _image,
        _imageData: _imageData,
        _item: _item,
        _itemImage: _itemImage,
        _itemStyle: _itemStyle,
        _itemVideo: _itemVideo,
        _mapData: _mapData,
        _mapSettings: _mapSettings,
        _media: _media,
        _metadata: _metadata,
        _metrics: _metrics,
        _moderationDetails: _moderationDetails,
        _node: _node,
        _option: _option,
        _poll: _poll,
        _pollData: _pollData,
        _pollDesign: _pollDesign,
        _post: _post,
        _richContent: _richContent,
        _video: _video,
        _videoData: _videoData,
        _videoResolution: _videoResolution,
        _videoV2: _videoV2,
        _wixMedia: _wixMedia,
    }).fromJSON;
    function __listPostsArchive(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.ListPostsArchive',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/archive',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPostsArchive.fromReq = fromReq;
    __listPostsArchive.__isAmbassador = true;
    return __listPostsArchive;
}
/** Retrieves reactions of the current user for specified posts. */
export function bulkGetPostReactions(payload) {
    var _a = serializer(_bulkGetPostReactionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetPostReactionsResponse, {}).fromJSON;
    function __bulkGetPostReactions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'POST',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.v3.PostService.BulkGetPostReactions',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogV3PostServiceUrl({
                protoPath: '/v3/posts/reactions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetPostReactions.fromReq = fromReq;
    __bulkGetPostReactions.__isAmbassador = true;
    return __bulkGetPostReactions;
}
/**
 * Retrieves the number of posts per month published within a specified time span, from first day of a month - ignoring days value in period start field.
 * If `periodStart` value is set to `2018-11-10` and `months` value is set to `1`, the day value is ignored and statistic are returned for one month from
 * `2018-11-01` until `2018-11-30` and not between `2018-11-10` and `2018-12-10`.
 */
export function queryPublicationsCountStats(payload) {
    var _a = serializer(_queryPublicationsCountStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPublicationsCountStatsResponse, { _periodPublicationsCount: _periodPublicationsCount }).fromJSON;
    function __queryPublicationsCountStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.BlogStatsService.QueryPublicationsCountStats',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
                protoPath: '/v2/stats/publications/count',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPublicationsCountStats.fromReq = fromReq;
    __queryPublicationsCountStats.__isAmbassador = true;
    return __queryPublicationsCountStats;
}
/**
 * Retrieves the number of published posts per month within a specified time range.
 *
 * The time range is set using the `rangeStart` and `months` properties.
 * The time range always starts on the 1st day of the month set in `rangeStart` and
 * includes the number of `months` following `rangeStart`.
 * For example, if `rangeStart` is set to `'2022-03-13'` and `months` is set to `4`,
 * the time range will be from `'2022-03-01'` until `'2022-06-30'`. The time range always ends on the last day of the month.
 * > Note: If there are no published posts in a month within the time range, that month is not included in the response. For example, let's say a blog has `0` posts dated in February 2022. If `rangeStart` is set to `'2022-01-01'` and `months` is set to `3`, the response includes `postCount` values for January and March, but not February.
 */
export function queryPostCountStats(payload) {
    var _a = serializer(_queryPostCountStatsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryPostCountStatsResponse, {
        _periodPostCount: _periodPostCount,
    }).fromJSON;
    function __queryPostCountStats(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.BlogStatsService.QueryPostCountStats',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
                protoPath: '/v2/stats/post/count',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryPostCountStats.fromReq = fromReq;
    __queryPostCountStats.__isAmbassador = true;
    return __queryPostCountStats;
}
/** Retrieves the amount of published posts for the current blog. */
export function getTotalPublications(payload) {
    var _a = serializer(_getTotalPublicationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTotalPublicationsResponse, {}).fromJSON;
    function __getTotalPublications(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.BlogStatsService.GetTotalPublications',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
                protoPath: '/v2/stats/publications/total',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTotalPublications.fromReq = fromReq;
    __getTotalPublications.__isAmbassador = true;
    return __getTotalPublications;
}
/** Gets the total amount of published posts of the blog. */
export function getTotalPosts(payload) {
    var _a = serializer(_getTotalPostsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTotalPostsResponse, {}).fromJSON;
    function __getTotalPosts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'com.wixpress.npm.communities.platformized.blog.BlogStatsService.GetTotalPosts',
            url: resolveComWixpressNpmCommunitiesPlatformizedBlogBlogStatsServiceUrl({
                protoPath: '/v2/stats/posts/total',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTotalPosts.fromReq = fromReq;
    __getTotalPosts.__isAmbassador = true;
    return __getTotalPosts;
}
export function sendActionEvent(payload) {
    var _a = serializer(_sendActionEventRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendActionEventResponse, {}).fromJSON;
    function __sendActionEvent(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.blog.v3.post',
            method: 'GET',
            methodFqn: 'wix.blog.kafka.producer.v1.PostKafkaProducer.SendActionEvent',
            url: resolveWixBlogKafkaProducerV1PostKafkaProducerUrl({
                protoPath: '/v1/send-action-event',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendActionEvent.fromReq = fromReq;
    __sendActionEvent.__isAmbassador = true;
    return __sendActionEvent;
}
//# sourceMappingURL=http.impl.js.map